module.exports = __webpack_public_path__ + "static/media/icon-autre.9c5edc10.svg";